import { render, staticRenderFns } from "./CountryPieChart.vue?vue&type=template&id=257c8489"
import script from "./CountryPieChart.vue?vue&type=script&lang=js"
export * from "./CountryPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports